var map = {
	"./text05_01.png": "b439",
	"./text05_02.png": "d42a",
	"./text05_03.png": "12bc",
	"./text05_04.png": "088a",
	"./text05_05.png": "145f",
	"./text05_06.png": "dd4b",
	"./text05_07.png": "3e06",
	"./text05_08.png": "dc2b",
	"./text05_09.png": "02a7",
	"./text05_10.png": "e1c2",
	"./text05_11.png": "ae74",
	"./text05_12.png": "3816",
	"./text05_13.png": "86bf",
	"./text05_14.png": "3562",
	"./text05_15.png": "69a4",
	"./text05_16.png": "8a6a",
	"./text05_17.png": "e5a9",
	"./text05_18.png": "78b9",
	"./text05_19.png": "b749",
	"./text05_20.png": "d7fc",
	"./text05_21.png": "f87b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43c4";